// dayjs formats
import Lang from '@/modules/core/app/services/Lang';

export const DateFormat = {
  ISO: 'YYYY-MM-DD', // 2021-10-27
  ISO_TIME: 'YYYY-MM-DD HH:mm', // 2021-10-27 23:21
  ISO_TIME_WITH_SECONDS: 'YYYY-MM-DD HH:mm:ss', // 2023-09-10 18:08:54
  ISO_TIME_WITH_MERIDIEM: 'YYYY-MM-DD hh:mm A', // 2021-10-27 11:21 PM
  ISO_TIME_WITH_TIMEZONE: 'YYYY-MM-DDTHH:mm:ssZ', // 2021-10-27T23:21:00+05:30
  MONTH_DAY: 'MMM DD', // Oct 27
  get FULL_MONTH_DAY() {
    return Lang.t('date.FULL_MONTH_DAY'); // 'MMMM DD', October 27th
  },
  get MONTH_DAY_WITH_TWELVE_HOUR() {
    return Lang.t('date.MONTH_DAY_WITH_TWELVE_HOUR'); // MMMM DD, [at] hh:mm A - October 27, at 11:30 PM
  },
  get MONTH_DAY_YEAR() {
    return Lang.t('date.MONTH_DAY_YEAR'); // 'MMM DD, YYYY' - Oct 27, 2021
  },
  get FULL_MONTH_DAY_YEAR() {
    return Lang.t('date.FULL_MONTH_DAY_YEAR'); // 'MMMM DD, YYYY' - October 27, 2021
  },
  get FULL_MONTH_DAY_YEAR_WITH_TWELVE_HOUR() {
    return Lang.t('date.FULL_MONTH_DAY_YEAR_WITH_TWELVE_HOUR'); // October 27, 2021 at 09:21 PM
  },
  get WEEKDAY_FULL_MONTH_DAY_YEAR_WITH_TWELVE_HOUR() {
    return Lang.t('date.WEEKDAY_FULL_MONTH_DAY_YEAR_WITH_TWELVE_HOUR'); // Tuesday, April 14, 2026, at 2:15 PM
  },
  DAY_MONTH_YEAR: 'DD MMM YYYY', // 27 Oct 2021
  DAY_FULL_MONTH_YEAR: 'DD MMMM YYYY', // 27 October 2021
  FULL_DAY_MONTH_YEAR: 'DD MMM YYYY', // 27 Oct 2021
  TIME: 'HH:mm', // 23:21
  TIME_MERIDIEM: 'hh:mm a', // 11:21 pm
  TIME_MERIDIEM_UPPERCASE: 'hh:mm A', // 11:21 pm
  DAYOFWEEK_MONTH_DAY_YEAR: 'ddd MMM DD YYYY', // Wed Oct 27 2021
  DAYOFWEEK_DAY_MONTH_YEAR_WITH_TIMEZONE: 'ddd, DD MMM YYYY HH:mm:ss ZZ', // Wed, Oct 27 2021 23:21:00 +0530
  MONTH_DAY_YEAR_TWELVE_HOUR: 'MMM DD, YYYY hh:mm A',
  MONTH_DAY_WITH_ORDINAL_TWELVE_HOUR: 'MMM Do YYYY, hh:mm A', // Oct 27, 2021 11:21 PM
  MONTH_DAY_YEAR_WITH_ORDINAL: 'MMM Do YYYY', // Oct 27th 2021
  FULL_MONTH_DAY_YEAR_WITH_ORDINAL: 'MMMM Do, YYYY', // October 27th, 2021
  MONTH_YEAR: 'MMM YYYY', // Aug 2021
  MONTH_YEAR_FULL: 'MMMM YYYY', // August 2021
  YEAR_MONTH_NO_SPACE: 'YYYYMM', // 202110
  DAYOFMONTH_MONTH_YEAR_WITH_ORDINAL: 'Do MMM YYYY', // 27th Oct 2021
  DAY_MONTH_YEAR_HYPHEN: 'DD-MM-YYYY', // 27-10-2021
  MONTH_DAY_YEAR_HYPHEN: 'MM-DD-YYYY', // 10-27-2021
  DAY_MONTH_YEAR_HYPHEN_TIME: 'DD-MMM-YYYY, HH:MM A', // 27-Oct-2021, 11:21 PM
  YEAR: 'YYYY', // 2021
  MONTH: 'MM', // 01
  MONTH_UPPERCASE: 'MMM', // MAR
  FULL_MONTH: 'MMMM', // January
  DAY: 'DD', // 01
  DAY_SINGLE_DIGIT: 'D', // 1
  MONTH_DAY_YEAR_SLASH: 'MM/DD/YYYY', // 10/27/2021
  DAY_OF_THE_WEEK: 'ddd', // Wed
  LOCALIZED_DAY_MONTH_YEAR: 'LL', // en: October 27, 2021 fr: 27 octobre 2021
  MONTH_DAY_WITH_DAY_OF_WEEK: 'MMM D (ddd)', // Nov 6 (WED)
  FULL_MONTH_DAY_YEAR_WITH_DAY_OF_WEEK: 'MMMM D, YYYY (dddd)' // November 6, 2021 (Wednesday)
};

export const DateRatio = {
  MS_PER_YEAR: 31536000000
};
